/*
 * File: CustomHomepage.tsx
 * Project: a-a
 * File Created: Sunday, 5th January 2025 9:59:48 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 19th May 2026 9:48:35 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { ReactElement, ReactNode } from 'react';
import CustomAlert from '../CustomAlert/CustomAlert';
import CustomTab from '../CustomTab/CustomTab';
import DashboardDealCard from '../CustomDashboard/Overview/DashboardDealCard';
import { Box, Typography } from '@mui/material';
import CustomHeadline from '../CustomHeadline/CustomHeadline';
import zeplinColor from '../../../theme/Color';
import { Constants } from '../../../utilities/constants';
import CustomCard from '../CustomCard/CustomCard';
import { Link } from 'react-router-dom';
import CustomAlertContain from '../CustomAlert/CustomAlertContain';
import CustomButton from '../CustomButton/CustomButton';
import { LightTooltip } from '../CustomTooltip/CustomTooltip';

const CustomHomepage = ({
  sportsData,
  ProfileDetails,
  DealCard,
  DashboardTabs,
  handleChange,
  value,
  alert,
  handleClose,
  Children,
  customHeader,
  CTA,
}: {
  sportsData: any;
  ProfileDetails?: ReactElement;
  DealCard?: ReactElement;
  DashboardTabs: any;
  handleChange: any;
  value: any;
  alert: any;
  handleClose: any;
  Children?: ReactNode;
  customHeader?: ReactElement;
  CTA?: JSX.Element;
}) => {
  const today = new Date();

  const formattedDate = today.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ position: 'sticky', top: 0 }}>
        {sportsData?.length ? (
          <Box>
            <CustomHeadline sportsData={sportsData} />
          </Box>
        ) : (
          ''
        )}
        {customHeader ? (
          <>{customHeader}</>
        ) : (
          <Box
            sx={{
              top: '16px',
              backgroundColor: zeplinColor.BasicBlack,
              color: zeplinColor.Neutral1,
              // display: 'inline',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '16px 24px',
              gap: '29px',
              // flex: 1,
              // height: '140px',
            }}
          >
            {ProfileDetails}
            {DealCard}
          </Box>
        )}
      </Box>

      <Box
        sx={{
          padding: { xs: '20px 16px 0rem 16px', xl: '24px 1.5rem 0rem 1.5rem' },
          flexGrow: 1,
          // overflowY: 'auto',
          // height: '75vh',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          flex: 1,
          // position: 'relative',
        }}
      >
        <CustomTab tabs={DashboardTabs} handleChange={handleChange} value={value} />
        {CTA && (
          <Box
            sx={{
              position: 'absolute',
              top: { xs: '20px', xl: '24px' },
              right: { xs: '16px', xl: '1.5rem' },
            }}
          >
            {CTA}
          </Box>
        )}
      </Box>

      <CustomAlert
        open={alert ? true : false}
        handleClose={handleClose}
        message={
          <CustomAlertContain
            alertIcon={
              !alert?.includes('successful') ? (
                <img src='/assets/error.svg' width={24} height={24} />
              ) : (
                <img src='/assets/checkmark-green.png' width={24} height={24} />
              )
            }
            alert={alert}
            error={!alert?.includes('successful') ? true : false}
          />
        }
        error={!alert?.includes('successful') ? true : false}
      />
      {Children}
    </Box>
  );
};

export default CustomHomepage;
